<a tabindex="0" class="aLinks"
   (click)="verfuegbar ? dialogOpen() : false" [class.web]="environment.type == 'web'" [class.inaktiv]="!verfuegbar" [class.tooltip]="!verfuegbar"
   (keydown.enter)="verfuegbar ? dialogOpen() : false" [class.web]="environment.type == 'web'" [class.inaktiv]="!verfuegbar" [class.tooltip]="!verfuegbar">
  <mat-icon [class.wba]="mobil" [class.inaktiv]="!verfuegbar">free_cancellation</mat-icon>
  <span *ngIf="!mobil && beschriftung">Express-Storno</span>
  <span class="tooltiptext" *ngIf="environment.type !== 'mobil' && !verfuegbar">Funktion steht im Warenkorb nicht zur Verfügung</span>
</a>
